import { QueryClient } from "@tanstack/react-query";
import { getStore } from "src/store";
import { alertSlice } from "src/store/alert/alert.slice";

const errorHandler = (error) => {
  getStore().dispatch(
    alertSlice.actions.setAlert({
      severity: "error",
      open: true,
      message: error?.response?.data?.message ?? "Some Error Occured!",
    })
  );
};
const createQueryClient = () => {
  let queryClient;
  return () => {
    if (!queryClient) {
      queryClient = new QueryClient({
        defaultOptions: {
          queries: {
            retry: 1,
            refetchOnWindowFocus: false,
            // Data is considered fresh for 5 minutes — prevents redundant refetches
            // on tab switch or component remount
            staleTime: 5 * 60 * 1000,
            // Keep unused cache entries for 10 minutes before garbage-collecting
            cacheTime: 10 * 60 * 1000,
            onError: errorHandler,
          },
        },
      });
    }
    return queryClient;
  };
};

export const getQueryClient = createQueryClient();
